import { useFocusEffect } from 'expo-router';
import useGetConsumerReportsAccount from 'features/advance/hooks/lightning/craUpgrade/useGetConsumerReportsAccount';
import { useCallback, useState } from 'react';

interface UseFocusedConsumerReportsAccountOptions {
  requestPolicy: 'network-only' | 'cache-and-network';
}

export const useFocusedConsumerReportsAccount = ({
  requestPolicy,
}: UseFocusedConsumerReportsAccountOptions) => {
  const [isConsumerReportPaused, setIsConsumerReportPaused] =
    useState<boolean>(true);

  useFocusEffect(
    useCallback(() => {
      setIsConsumerReportPaused(false);

      return () => {
        setIsConsumerReportPaused(true);
      };
    }, []),
  );

  const queryResult = useGetConsumerReportsAccount({
    pause: isConsumerReportPaused,
    requestPolicy,
  });

  return {
    ...queryResult,
    isConsumerReportPaused,
  };
};

export default useFocusedConsumerReportsAccount;
